import API_PUBLIC_SERVICE, { SERVER_API, JString, publicInstance } from './http';
import { rutFormat, dateFormat, cleanCharacters } from '../libraries/formatters';

import { SUBSCRIPTOR_RESULT_PATH } from '../routers/subscriptor';

const PREFIX = 'evaluations';
const path = PREFIX;

const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'subscriberRut',
      key: 'subscriberInfo.rut',
      disablePadding: false,
      numeric: false,
      label: 'Rut Suscriptor',
      style: {
        width: '170px'
      },
      format: rutFormat
    },
    {
      id: 'endorsementRut',
      key: 'endorsementInfo.rut',
      disablePadding: false,
      numeric: false,
      label: 'Rut Aval',
      style: {
        width: '170px'
      },
      format: rutFormat
    },
    {
      id: 'patientRut',
      key: 'patientInfo.rut',
      disablePadding: false,
      numeric: false,
      label: 'Rut Paciente',
      style: {
        width: '170px'
      },
      format: rutFormat
    },
    {
      id: 'createdAt',
      disablePadding: false,
      numeric: false,
      label: 'Fecha Evaluación',
      format: dateFormat('DD-MM-YYYY')
    },
    {
      id: 'state',
      disablePadding: false,
      numeric: false,
      label: 'Decisión'
    },
    {
      id: 'requestId',
      key: 'requestId',
      disablePadding: false,
      numeric: false,
      label: 'ID Solicitud'
    }
  ],
  onRowClick: props => val => props.history.push(SUBSCRIPTOR_RESULT_PATH.replace(':id', val)),
  getKeyTable: () => '_id',
  makeDataTable: data =>
    data.map(elem => {
      const newElem = { ...elem };
      const decision = elem.response && elem.response.decision ? elem.response.decision : '';
      newElem.subscriberRut = elem.subscriberInfo ? elem.subscriberInfo.rut : '';
      newElem.endorsementRut = elem.endorsementInfo ? elem.endorsementInfo.rut : '';
      newElem.patientRut = elem.patientInfo ? elem.patientInfo.rut : '';
      newElem.state = decision ? decision : '';
      newElem.requestId =
        elem && elem.response && elem.response.requestId ? elem.response.requestId.toString() : '';
      return newElem;
    }),

  hasCheckbox: false
};

const makeData = json => {
  const endorsementInfo = {
    rut: `${json.avalDni}-${json.avalDniNumber}`,
    rutSerie: cleanCharacters(!json.avalCedula ? '' : json.avalCedula),
    address: {
      normalized: json.isavalNormalized,
      region: json.avalRegion.name,
      commune: json.avalCommune.nameEFX,
      address: json.avalAddress,
      number: json.avalAddressNumber,
      extra: json.avalAnexo
    },
    contributions: json.avalContributions,
    phone1: `+56${json.avalTel1}`,
    phone2: `+56${json.avalTel2}`,
    email: json.avalEmail
  };
  const data = {
    serviceRequest: {
      warranty: json.guaranteeType._id,
      risk: json.medicalRisk._id,
      budget: json.budgetAmount,
      deposit: json.amount,
      services: json.services.map(elem => elem._id)
    },

    subscriberInfo: {
      rut: `${json.suscriptorDni}-${json.suscriptorDniNumber}`,
      rutSerie: cleanCharacters(!json.suscriptorCedula ? '' : json.suscriptorCedula),
      address: {
        normalized: json.issuscriptorNormalized,
        region: json.suscriptorRegion.name,
        commune: json.suscriptorCommune.nameEFX,
        address: json.suscriptorAddress,
        number: json.suscriptorAddressNumber,
        extra: json.suscriptorAnexo
      },
      contributions: json.suscriptorContributions,
      phone1: `+56${json.suscriptorTel1}`,
      phone2: `+56${json.suscriptorTel2}`,
      email: json.suscriptorEmail
    },
    patientInfo: {
      rut: `${json.patientDni}-${json.patientDniNumber}`,
      insurance: json.patientInsurance._id,
      sameSubscriber: json.patientSuscriptorCb,
      oncologicalAgreement: json.patientOncologicalAgreementCb,
      supplementaryInsurance: json.patientComplementaryInsuranceCB
    }
  };

  if (json.allowEndorsement) {
    data.endorsementInfo = endorsementInfo;
  }

  if (json.patientPlanSection) {
    data.patientInfo.range = json.patientPlanSection._id;
  }

  return data;
};

const customEndpoints = {
  post: async json => {
    try {
      const res = await publicInstance.post(`${SERVER_API}${path}`, JString(makeData(json)));
      let { data } = await res;
      return data;
    } catch (err) {
      const {
        response: { data }
      } = await err;

      throw data;
    }
  }
};

const RequestService = {
  path,
  ...API_PUBLIC_SERVICE,
  ...tableData,
  ...customEndpoints
};

export default RequestService;
